import { useState, useEffect } from 'react';
import { Form, Cascader } from 'antd-mobile';
import { keysConstant } from 'utils/constant/key';

const { T_DIC_PROTECH, T_DIC_PROQUALITY, T_DIC_AREACODE } = keysConstant

/**
 * 树形级联选择器
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 * } props 
 * @returns 
 */
export function BpmFormCascader(props) {
  const { postName, label, message, required, key } = props.item
  const { content, skillContent, setSkillContent,
    getSkillObj, getPostObj, cityContent, setCityContent, getCityTreeObj,
    item, postContent, setPostContent, jobWantContent, setFormInfo } = props

  const [visible, setVisible] = useState(false)  // 控制选择框
  const [value] = useState([])  // 选中值
  const [options, setOptions] = useState([])  // 所有选择项

  useEffect(() => {
    key === T_DIC_PROTECH && setOptions(postContent)
    key === T_DIC_PROQUALITY && setOptions(skillContent)
    key === T_DIC_AREACODE && setOptions(cityContent)
  }, [key, cityContent, postContent, content, skillContent, jobWantContent])

  /** 点击选择项 */
  function handleOnSelect(extend, key) {
    setTimeout(() => {
      key === T_DIC_PROQUALITY && getSkillObj(extend.items, key, skillContent, setSkillContent)
      key === T_DIC_PROTECH && getPostObj(extend.items, key, postContent, setPostContent)
      key === T_DIC_AREACODE && getCityTreeObj(extend.items, key, cityContent, setCityContent)
      // key === 'place' && getJobWantedObj(extend.items)
    })
  }

  /** 点击确认按钮 */
  function handleOnConfirm(value, key) {
    const newValue = value[value.length - 1]
    setFormInfo(postName, newValue)
  }

  /** 打开/关闭 选择框 */
  function handleCascaderClick(state) {
    setVisible(state)
  }

  /** 显示在表单上字段 */
  function onValue(items) {
    if (items.every(item => item === null)) {
      return '请选择'
    } else {
      return items[items.length - 1].label
    }
  }


  return (
    <Form.Item
      name={postName}
      label={label}
      rules={[{ required: required, message: message }]}
      trigger='onConfirm'
      onClick={() => handleCascaderClick(true)}
    >
      <Cascader
        options={options?.length ? options : [{ label: '暂无数据' }]}
        visible={visible}
        onClose={() => handleCascaderClick(false)}
        value={value}
        onConfirm={value => {
          handleOnConfirm(value, item.key)
        }}
        onSelect={(val, extend) => handleOnSelect(extend, item.key)}
      >
        {items => onValue(items)}
      </Cascader>
    </Form.Item>
  )
}
